import CalculadoraJs from "./Proyectos/Projects-img/Calculadora-JS.webp";
import CuentaRegresiva from "./Proyectos/Projects-img/CuentaRegresiva.webp";
import PiedraPapelOTijeras from "./Proyectos/Projects-img/PiedraPapelOTijeras.webp";
import SimonGame from "./Proyectos/Projects-img/Simon-game.webp";
import TaTeTiGame from "./Proyectos/Projects-img/Ta-Te-Ti-Game.webp";
import EcommercePlantasCarnivoras from "./Proyectos/Projects-img/Ecommerce-PlantasCarnivoras.webp";
import paqueteTuristicoLandingPage from "./Proyectos/Projects-img/paqueteTuristico-LandingPage.webp";
import englishSmart from "./Proyectos/Projects-img/english-smart.webp";
import aquarnemc from "./Proyectos/Projects-img/aquarne-mc.webp";
import Monetrix from "./Proyectos/Projects-img/Monetrix.webp";
import CoderPlate40 from "./Proyectos/Projects-img/CoderPlate40.webp";
import JikesShop from "./Proyectos/Projects-img/JikesShop.webp";
import LazonaRoleplay from "./Proyectos/Projects-img/LazonaRoleplay.png";
import webEcommerce from "./Proyectos/Projects-img/web-ecommerce.png";
import CoderPlate40Agencia from "./Proyectos/Projects-img/CoderPlate40-agencia.webp";
import kgurban from "./Proyectos/Projects-img/kgurban.png";

const projectData = [
  {
    id: 1,
    imagen: kgurban,
    titulo: "KG Urban - Tienda Online",
    tecnologias: "ReactJs, ExpressJs and MongoDB.",
    text: "KG Urban es una tienda online de Relojes y Perfumes funcionando en el mercado Argentino desde Julio del 2025 a la actualidad. Cuenta con Dashboard con intefaz y codigo individual con todo lo necesario para la gestión de la tienda y los productos (stock, nuevos productos, pedidos, estados de envio y hasta envio de mails masivos).",
    linkWebside: "https://kgurban.com.ar/",
    linkRepository: "/",
  },
  {
    id: 2,
    imagen: CoderPlate40Agencia,
    titulo: "CoderPlate40Titulo",
    tecnologias: "ReactJs, ExpressJs and MongoDB.",
    text: "textCoderplate40",
    linkWebside: "https://coderplateagencia.netlify.app/",
    linkRepository: "/",
  },
  {
    id: 3,
    imagen: CoderPlate40,
    titulo: "CoderPlate40TituloViejo",
    tecnologias: "ReactJs, ExpressJs and MongoDB.",
    text: "textCoderplate40Viejo",
    linkWebside: "https://codereplate.netlify.app/",
    linkRepository: "/",
  },
  {
    id: 4,
    imagen: JikesShop,
    titulo: "JikesShopTitulo",
    tecnologias: "ReactJs, Express and MongoDB.",
    text: "textJikesshop",
    linkWebside: "https://jikesshop.netlify.app",
    linkRepository: "/",
  },
  {
    id: 5,
    imagen: LazonaRoleplay,
    titulo: "Lazona Roleplay",
    tecnologias: "ReactJs and Mysql.",
    text: "textLazonaRoleplay",
    linkWebside: "https://lazonarp.netlify.app/",
    linkRepository: "/",
  },
  {
    id: 6,
    imagen: Monetrix,
    titulo: "MonetrixTitulo",
    tecnologias: "ReactJs, Bootstrap, Express and Mysql.",
    text: "textMonetrix",
    linkWebside: "https://web-smartbet.netlify.app/",
    linkRepository: "/",
  },

  {
    id: 7,
    imagen: englishSmart,
    titulo: "englishsmartTitulo",
    tecnologias: "REACT, Bootstrap, Express and Mysql.",
    text: "textenglishSmart",
    linkWebside: "https://english-smart.netlify.app/",
    linkRepository: "/",
  },
  {
    id: 8,
    imagen: paqueteTuristicoLandingPage,
    titulo: "paqueteTuristicoLandingPageTitulo",
    tecnologias: "Material UI, REACT.",
    text: "textpaqueteTuristicoLandingPage",
    linkWebside: "https://pagina-aerolineas.netlify.app/",
    linkRepository: "/",
    // linkRepository:
    //   "https://github.com/kevingonzalo/pagina-aerolineas-LandingPage",
  },
];
export default projectData;
